// export const appLinks = [
//   { name: 'Insight', url: 'http://localhost:3000', logo: '/app-logos/Insight.png' },
//   { name: 'Xtract', url: 'http://localhost:3000/user/dashboard', logo: '/app-logos/Xtract.png' },
//   { name: 'KMS', url: 'http://localhost:3003', logo: '/app-logos/KMS.png' },
//   { name: 'QMS', url: 'http://localhost:3004', logo: '/app-logos/QMS.png' },
//   { name: 'Immerse', url: 'http://localhost:3005', logo: '/app-logos/Immerse.png' },
//   { name: 'Propel', url: 'http://localhost:3006', logo: '/app-logos/Propel.png' },
//   { name: 'Telephony', url: 'http://localhost:3007', logo: '/app-logos/Telephony.png' },
// ];

export const appLinks = [
  { name: 'Insight', url: 'https://insight.ind4.convolink.ai', logo: '/app-logos/Insight.png' },
  { name: 'Xtract', url: 'https://xtract.ind4.convolink.ai', logo: '/app-logos/Xtract.png' },
  { name: 'KMS', url: 'https://kms.convolink.ai', logo: '/app-logos/KMS.png' },
  { name: 'QMS', url: 'https://qms.ind4.convolink.ai', logo: '/app-logos/QMS.png' },
  { name: 'Immerse', url: 'https://immerse.ind4.convolink.ai', logo: '/app-logos/Immerse.png' },
  { name: 'Propel', url: 'https://propel.ind4.convolink.ai', logo: '/app-logos/Propel.png' },
  { name: 'Virtual Assist', url: 'https://assist.ind4.convolink.ai', logo: '/app-logos/VirtualAssist.png' },
];